import { Card, CardContent, Stack, Typography } from '@mui/material';
import SteamIcon from '../SteamIcon';

const bulletPoints = [
  'Uses Steam\'s official login — we never see your Steam password',
  'Syncs your recent games and what you\'re playing now',
  'Shows activity for mutual Steam friends on GamingWithBros only',
  'Does not post to Steam or change your Steam profile',
];

export default function SteamSignInExplainer() {
  return (
    <Card
      elevation={0}
      sx={{
        width: '100%',
        textAlign: 'left',
        bgcolor: '#1e293b',
        border: '1px solid rgba(148, 163, 184, 0.35)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
      }}
    >
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems={{ sm: 'flex-start' }}>
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              mx: { xs: 'auto', sm: 0 },
              flexShrink: 0,
              width: 88,
              height: 88,
              borderRadius: 2,
              bgcolor: '#0f172a',
              border: '1px solid rgba(125, 211, 252, 0.35)',
              color: '#e0f2fe',
            }}
          >
            <SteamIcon size={52} />
          </Stack>

          <Stack spacing={2.5} sx={{ minWidth: 0 }}>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: '1.35rem', sm: '1.5rem' },
                fontWeight: 700,
                lineHeight: 1.3,
                color: '#ffffff',
              }}
            >
              What does Sign in with Steam do?
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: '1.0625rem', sm: '1.125rem' },
                fontWeight: 500,
                lineHeight: 1.75,
                color: '#f1f5f9',
              }}
            >
              Signing in links your Steam account to GamingWithBros so you can see what your
              friends are playing — only friends who have signed up here too.
            </Typography>

            <Stack component="ul" spacing={1.75} sx={{ m: 0, pl: 2.5, listStyleType: 'disc' }}>
              {bulletPoints.map((point) => (
                <Typography
                  key={point}
                  component="li"
                  sx={{
                    fontSize: { xs: '1rem', sm: '1.0625rem' },
                    fontWeight: 500,
                    lineHeight: 1.7,
                    color: '#e2e8f0',
                    display: 'list-item',
                  }}
                >
                  {point}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
